import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { PERMISSION_CHECK } from '@/utils/constants';
import { isAPICatchError, sortByProperty, sortByPropertyLowerCase } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import { copy } from '@/utils/cohort';

@Component({
    name: 'tenant-list',
    components: {
        'date-range-picker': DateRangePicker,
    },
})

export default class TenantList extends Vue {
    private tenantList: any = [];

    private permissonCheck = PERMISSION_CHECK;

    private isLoading: boolean = false;

    private limit: number = 10;

    private offset: number = 0;

    private perPage: number = 10;

    private totalRowCounts: number = 10;

    private currentPage: number = 1;

    private tenantTableFields: any = [
        {
            label: 'Logo',
            key: 'image_url',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Tenant name',
            key: 'name',
            thClass: 'align-middle text-center name-head',
            tdClass: 'align-middle',
        },
        {
            label: 'Short name',
            key: 'short_name',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Login type',
            key: 'grant_types',
            thClass: 'grant-types align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Roster Method',
            key: 'roster_format',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Total users',
            key: '',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Teachers',
            key: 'count.teacher',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Students',
            key: 'count.student',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Admins',
            key: 'count.admin',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Active teachers',
            key: 'active.teachers',
            thClass: 'align-middle text-center text-success',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Active students',
            key: 'active.students',
            thClass: 'align-middle text-center text-success',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Status',
            key: 'status',
            thClass: 'align-middle text-center',
            tdClass: 'align-middle text-center',
        },
        {
            label: 'Actions',
            key: 'actions',
            thClass: 'align-middle text-center',
            tdClass: 'relative-position align-middle text-center',
        },
    ];

    private filterList: any = [
        {
            key: 'dateRange',
            label: 'Date range',
        },
    ];

    private isShowDateFilter: boolean = false;

    private searchText: any = '';

    private searchItem: any = {
        searchTxt: '',
        dateRange: '',
    };

    private selectedFilterItem: any = [];

    private dateRange: any = {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: new Date(),
    };


    private created() {
        this.getTenantList();
    }

    private getTenantList() {
        this.isLoading = true;
        const params: any = {
            offset: this.offset,
            limit: this.limit,
        };
        if (this.searchText) {
            params.search_terms = this.searchText;
        }
        if (this.searchItem.dateRange) {
            const dataRange = copy(this.dateRange);
            params.fromDate = moment(dataRange.startDate).format('YYYY-MM-DD');
            params.toDate = moment(dataRange.endDate).format('YYYY-MM-DD');
        }
        adminUtilsAPI.fetchTenantList(params).then((data: any) => {
            this.isLoading = false;
            if (!isAPICatchError(data)) {
                sortByPropertyLowerCase(data.list, 'name', 'ASC');
                this.tenantList = this.skipAnonymous(data.list);
                this.totalRowCounts = data.total_count;
            }
        });
    }

    private skipAnonymous(list: any) {
        for (const iterator of list) {
            const anonymousIndex = iterator.grant_types.findIndex((item: any) => item === 'anonymous');
            if (anonymousIndex !== -1) {
                iterator.grant_types.splice(anonymousIndex, 1);
            }
        }
        return list;
    }

    private onSwitchComponent(key: any) {
        // return;
        this.$emit('onSwitchComponent', key);
    }

    private onDelete(item: any) {
        // console.log('item-delet', item);
        const test = '';
    }

    private onEdit(item: any) {
        if (this.$access.isHavingPermisson(this.permissonCheck.editTenant)) {
            const passItem = item;
        }
    }

    private updateValues() {
        this.offset = 0;
        const dataRange = copy(this.dateRange);
        const stringDate = `Date: ${moment(dataRange.startDate).format('YYYY-MM-DD')} to ${moment(dataRange.endDate).format('YYYY-MM-DD')}`;
        this.searchItem.dateRange = stringDate;
        this.getTenantList();
    }

    private onSelectFilter(item: any) {
        const filterIndex = this.selectedFilterItem.findIndex((filterItem: any) => filterItem === item.key);
        if (filterIndex === -1) {
            this.selectedFilterItem.push(item.key);
        } else {
            this.selectedFilterItem.splice(filterIndex, 1);
        }
    }

    private onSearch(text: any) {
        this.searchItem.searchTxt = text;
        this.offset = 0;
        this.getTenantList();
    }

    private removeSearchPart(item: any) {
        this.offset = 0;
        if (item === 'text') {
            this.searchItem.searchTxt = '';
            this.searchText = '';
        } else if (item === 'date') {
            this.searchItem.dateRange = '';
            this.dateRange = {};
        }
        this.getTenantList();
    }

    private showDateFilter() {
        this.isShowDateFilter = true;
    }

    private onSelectPage(pageNumber: number) {
        this.tenantList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.getTenantList();
    }
}
